import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { IFrameworkResource } from "../../frameworks";
import { TrainingActionType } from "../../training-actions";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ITrainingTemplateResource, TrainingTemplateStatus } from "../types";

export interface ITrainingTemplateCreateMutationParameters {
    description?: string;
    status?: TrainingTemplateStatus;
    jobFramework?: RelationalValue<IFrameworkResource>;
    specificFrameworks?: RelationalValue<IFrameworkResource>[];
    transversalSkillsFramework?: boolean;
    actions?: Array<{
        type: TrainingActionType;
        duration: number;
        calendarUnit?: "month" | "day" | "hour";
        pedagogicalHours: number;
        description: string;
    }>;
}

export type ITrainingTemplateCreateMutationResult = ITrainingTemplateResource;

export const trainingTemplateCreateMutation: IApiMutationFunction<ITrainingTemplateCreateMutationParameters> = ({
    description = "",
    jobFramework,
    specificFrameworks = [],
    actions = [],
    status = TrainingTemplateStatus.DRAFT,
    transversalSkillsFramework = true,
}) => {
    return {
        method: "POST",
        url: "/training_templates",
        data: {
            uuid: uuid(),
            description,
            jobFramework: jobFramework ? mapRelationalValueAsIRI(EntityTypes.FRAMEWORK, jobFramework) : null,
            specificFrameworks: specificFrameworks.map(framework =>
                mapRelationalValueAsIRI(EntityTypes.FRAMEWORK, framework),
            ),
            transversalSkillsFramework,
            trainingActions: actions.map(action => ({
                type: action.type,
                calendarDuration: action.duration,
                calendarUnit: action.calendarUnit ?? "month",
                pedagogicalHours: action.pedagogicalHours,
                description: action.description ?? "",
            })),
            status: status,
        },
    };
};

export const useTrainingTemplateCreateMutation = createApiMutationHook<
    ITrainingTemplateCreateMutationParameters,
    ITrainingTemplateCreateMutationResult
>(trainingTemplateCreateMutation);
